import img from '../../helpers/img';

export default {
  title: 'Tally24',
  tile: {
    grid: 'col-12 lap-3',
    bgImage: img('tally24/tally24-hero.jpg')
  },
  hero: {
    bgImage: img('tally24/tally24-hero.jpg'),
    bgPosition: 'top'
  },
  info: {
    client: 'CDSEO',
    timeline: 'Nov 2012 - Nov 2013',
    description: [
      'CDSEO, a small agency in San Francisco, contracted me for a year to build Tally24, a web app for booking classes.',
      'I designed the UI and architected the front end with a custom client-side MVC.'
    ],
    tools: `
      PHP,
      JS,
      jQuery Mobile,
      SASS,
      FontAwesome,
      Google Maps,
      Google Chart Tools
    `,
    buttons: []
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('tally24/tally24-hero.jpg'),
      caption: 'Tally24 Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6 desk-4',
      thumb: img('tally24/tally24-calendar.jpg'),
      caption: 'Tally24 Calendar'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6 desk-4',
      thumb: img('tally24/tally24-analytics.jpg'),
      caption: 'Tally24 Analytics'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6 desk-4',
      thumb: img('tally24/tally24-profile.jpg'),
      caption: 'Tally24 Profile'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/tally24.js